import script from "./PlanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanModal.vue?vue&type=script&setup=true&lang=js"

import "./PlanModal.vue?vue&type=style&index=0&id=5331696b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5331696b"]])

export default __exports__